import { ConfigStateService, LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfigurationSettingsDto } from 'src/core/models/configuration-setting/configuration-settings.dto';
import { ConfigurationSettingsService } from 'src/core/services/configuration-settings/configuration-settings.service';
import { StringValidator } from 'src/core/validators/shared/string.validator';

@Component({
  selector: 'cr-five9-integration-settings',
  templateUrl: './five9-integration-settings.component.html',
  styleUrls: ['./five9-integration-settings.component.scss'],
})
export class Five9IntegrationSettingsComponent implements OnInit {
  form: FormGroup;

  private readonly prefix = 'Five9Integration';
  private readonly caSkillIdFor = `${this.prefix}.CASkillIdFor`;
  private readonly tenantName = `${this.prefix}.TenantName`;
  private readonly caClientId = `${this.prefix}.CAClientId`;
  private readonly caClientSecret = `${this.prefix}.CAClientSecret`;
  private readonly clientId = `${this.prefix}.ClientId`;
  private readonly clientSecret = `${this.prefix}.ClientSecret`;
  private readonly organizationId = `${this.prefix}.OrganizationId`;

  constructor(
    private fb: FormBuilder,
    private config: ConfigStateService,
    private settingService: ConfigurationSettingsService,
    private toastr: ToasterService,
    private localizationService: LocalizationService
  ) {
    this.form = this.fb.group({
      caSkillIdFor: this.fb.group({
        name: this.caSkillIdFor,
        value: [
          this.config.getSetting(this.caSkillIdFor),
          {
            validators: [Validators.required, StringValidator.whitespace],
          },
        ],
      }),
      tenantName: this.fb.group({
        name: this.tenantName,
        value: [
          this.config.getSetting(this.tenantName),
          {
            validators: [Validators.required, StringValidator.whitespace],
          },
        ],
      }),
      caClientId: this.fb.group({
        name: this.caClientId,
        value: [
          this.config.getSetting(this.caClientId),
          {
            validators: [Validators.required, StringValidator.whitespace],
          },
        ],
      }),
      caClientSecret: this.fb.group({
        name: this.caClientSecret,
        value: [
          this.config.getSetting(this.caClientSecret),
          {
            validators: [Validators.required, StringValidator.whitespace],
          },
        ],
      }),
      clientId: this.fb.group({
        name: this.clientId,
        value: [
          this.config.getSetting(this.clientId),
          {
            validators: [Validators.required, StringValidator.whitespace],
          },
        ],
      }),
      clientSecret: this.fb.group({
        name: this.clientSecret,
        value: [
          this.config.getSetting(this.clientSecret),
          {
            validators: [Validators.required, StringValidator.whitespace],
          },
        ],
      }),
      organizationId: this.fb.group({
        name: this.organizationId,
        value: [
          this.config.getSetting(this.organizationId),
          {
            validators: [Validators.required, StringValidator.whitespace],
          },
        ],
      })
    });
  }

  ngOnInit(): void {}

  onSubmitForm(eventArgs): void {
    if (!this.form.valid) {
      return;
    }

    const settings: ConfigurationSettingsDto[] = [];

    settings.push({
      settingName: this.form.get('caSkillIdFor').get('name').value,
      settingValue: this.form.get('caSkillIdFor').get('value').value,
    });

    settings.push({
      settingName: this.form.get('tenantName').get('name').value,
      settingValue: this.form.get('tenantName').get('value').value,
    });
    
    settings.push({
      settingName: this.form.get('caClientId').get('name').value,
      settingValue: this.form.get('caClientId').get('value').value,
    });

    settings.push({
      settingName: this.form.get('caClientSecret').get('name').value,
      settingValue: this.form.get('caClientSecret').get('value').value,
    });

    settings.push({
      settingName: this.form.get('clientId').get('name').value,
      settingValue: this.form.get('clientId').get('value').value,
    });

    settings.push({
      settingName: this.form.get('clientSecret').get('name').value,
      settingValue: this.form.get('clientSecret').get('value').value,
    });

    settings.push({
      settingName: this.form.get('organizationId').get('name').value,
      settingValue: this.form.get('organizationId').get('value').value,
    });

    this.settingService.saveSetting(settings).subscribe(res => {
      this.toastr.success(
        this.localizationService.instant('AbpSettingManagement::SuccessfullySaved')
      );
    });
  }
}
